(function () {
    pagination(true);
})();

(function () {
    if (!document.body.classList.contains('post-template')) return;

    const cover = document.querySelector('.gh-cover');
    if (!cover) return;

    const image = cover.querySelector('.gh-cover-image');

    window.addEventListener('load', function () {
        cover.style.setProperty('--cover-height', image.clientWidth * image.naturalHeight / image.naturalWidth + 'px');
        cover.classList.remove('loading');
    });
})();

(function () {
    const shareBtn = document.querySelector('[data-ns-share]');
    if (!shareBtn) return;

    shareBtn.addEventListener('click', function () {
        const title = document.querySelector('.ns-article-title');
        const url = window.location.href;
        const text = title ? title.textContent : '';

        if (navigator.share) {
            navigator.share({ title: text, url: url }).catch(function () {});
        } else {
            navigator.clipboard.writeText(url).then(function () {
                shareBtn.classList.add('ns-shared');
                shareBtn.querySelector('span').textContent = 'Copied';
                setTimeout(function () {
                    shareBtn.classList.remove('ns-shared');
                    shareBtn.querySelector('span').textContent = 'Share';
                }, 2000);
            });
        }
    });
})();


